// Email domain configuration
// These domains are verified in Postmark and can be used for venue emails

// Get verified domains from environment variable (comma-separated)
// Example: VERIFIED_EMAIL_DOMAINS=onairgameshows.com,yourdomain.com,anotherdomain.com
const domainsEnv = process.env.NEXT_PUBLIC_VERIFIED_EMAIL_DOMAINS || process.env.VERIFIED_EMAIL_DOMAINS || '';

// Parse domains from environment or use defaults
export const VERIFIED_EMAIL_DOMAINS: string[] = domainsEnv
  ? domainsEnv.split(',').map(domain => domain.trim().toLowerCase())
  : ['onairgameshows.com']; // Default fallback

// Helper function to check if an email belongs to a verified domain
export function isEmailFromVerifiedDomain(email: string): boolean {
  if (!email) return false;

  const emailLower = email.toLowerCase();
  return VERIFIED_EMAIL_DOMAINS.some(domain => emailLower.endsWith(`@${domain}`));
}

// Helper function to extract domain from email
export function getDomainFromEmail(email: string): string {
  if (!email || !email.includes('@')) return '';
  return email.split('@')[1]?.toLowerCase() || '';
}

// Helper function to check if a domain is verified
export function isVerifiedDomain(domain: string): boolean {
  if (!domain) return false;
  return VERIFIED_EMAIL_DOMAINS.includes(domain.toLowerCase());
}

// Get a formatted list of verified domains for display
export function getVerifiedDomainsDisplay(): string {
  return VERIFIED_EMAIL_DOMAINS.map(d => `@${d}`).join(', ');
}

// Get the primary/default domain (first in the list)
export function getPrimaryDomain(): string {
  return VERIFIED_EMAIL_DOMAINS[0] || 'example.com';
}

// Default email addresses using the primary domain
export function getDefaultEmails() {
  const primaryDomain = getPrimaryDomain();
  return {
    noreply: `noreply@${primaryDomain}`,
    support: `support@${primaryDomain}`,
  };
}